import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { observer } from "mobx-react";
import LinkV1 from 'ReactApp/Components/LinkV1/LinkV1';
import PV1 from 'ReactApp/Components/PV1/PV1';
import CartCountChangerV1 from 'ReactApp/Components/CartCountChangerV1/CartCountChangerV1';
// import DeliveryInfoL1V1 from 'ReactApp/Components/DeliveryInfoL1V1/DeliveryInfoL1V1';
import DeliveryInfoOldProjectV1 from 'ReactApp/Components/DeliveryInfoOldProjectV1/DeliveryInfoOldProjectV1';
import PriceBlockV2 from 'ReactApp/Components/PriceBlockV2/PriceBlockV2';
import CartProductCardFavoriteV1 from 'ReactApp/Components/CartProductCardFavoriteV1/CartProductCardFavoriteV1';
import CartProductCardDeleteV1 from 'ReactApp/Components/CartProductCardDeleteV1/CartProductCardDeleteV1';
import ImageV1 from 'ReactApp/Components/ImageV1/ImageV1';
import BadgeListV1 from 'ReactApp/Components/BadgeListV1/BadgeListV1';
import ProductCardV7AsCartGiftV1 from 'ReactApp/Components/ProductCardV7AsCartGiftV1/ProductCardV7AsCartGiftV1';
import RemoveShimV1 from '../RemoveShimV1/RemoveShimV1';
import { ProductTypeEnum } from 'ReactApp/Types/enum';

type ProductCardV6Props = {
    card: DomainNs.ProductCardV6Interface,
    cardIndex: number,
    isReadonlyMode: boolean,
}

const ProductCardV6 = observer((props: ProductCardV6Props) => {

    const renderArticul = (): string | React.JSX.Element => {
        return (
            <>
                <span>Артикул:&nbsp;</span><span>{props.card.articul}</span>
            </>
        );
    } 

    return (
        <>
            <div className="product-card-v6">
                <div className="product-card-v6__info-column">

                    <div className="product-card-v6__gallery-wrap">
                        {props.card.images.currentImage !== null && (
                            <ImageV1 {...{
                                src: props.card.images.currentImage.src,
                                alt: props.card.images.currentImage.alt,
                                loading: 'lazy'
                            }} />
                        )}
                        <BadgeListV1 {...{
                            badges: props.card.badges 
                        }} />
                    </div>

                    <div className="product-card-v6__desc-wrap">
                        <LinkV1 {...{
                            href: (props.card.url as string),
                            label: (props.card.title as string),
                            classes: [
                                'link-v1_text-color-type-text',
                                'link-v1_decoration-type-none'
                            ]
                        }} />
                        {props.card.currentRealModifier !== undefined && (
                            <div className="product-card-v6__rm">
                                Размер:&nbsp;
                                <strong>{props.card.currentRealModifier.label}</strong>
                            </div>
                        )}
                        {props.card.currentVirtualModifierAsTextile !== undefined && (
                            <div className="product-card-v6__vm">
                                Ткань:&nbsp; <strong>{props.card.currentVirtualModifierAsTextile.textileLabel}</strong>
                                <div className="textile-switcher-v1__option-wrap">
                                    <div
                                        className={[
                                            'textile-switcher-v1__option-block',
                                            'textile-switcher-v1__option-block_active',
                                        ].join(' ')}
                                        >
                                        <div className="textile-switcher-v1__option-image">                                                                        
                                            <img 
                                                className="image-v1"
                                                loading="lazy" 
                                                src={props.card.currentVirtualModifierAsTextile.imgSrc} 
                                                alt={props.card.currentVirtualModifierAsTextile.imgAlt}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {(typeof props.card.articul === 'string') && (
                        <PV1 {...{
                            text: renderArticul(),
                            classes: [
                                'product-card-v6__articul',
                                'p-v1_text-color-type-text'
                            ]
                        }} />
                    )}

                    <CartCountChangerV1 {...{
                        cartInfo: props.card.cartInfo,
                        cardIndex: props.cardIndex,
                        isReadonlyMode: props.isReadonlyMode,
                    }} />

                    {/* Временно заменяется на DeliveryInfoOldProjectV1 */}
                    {/* <DeliveryInfoL1V1 {...{
                        deliveryInfo: props.card.deliveryInfo,
                        card: props.card
                    }} /> */}

                    {
                        // доставка не отображается для режима редактирования
                        (props.isReadonlyMode === false) && (
                            <DeliveryInfoOldProjectV1 {...{
                                deliveryInfo: (
                                    props.card.deliveryInfo as DomainNs.DeliveryInfoOldProjectInterface
                                ),
                                card: props.card
                            }} />
                        )
                    }

                    <div className="product-card-v6__price-block">
                        <PriceBlockV2 {...{
                            salePrice: (
                                // теперь в цену продажи идет либо цена после
                                // применения промо-кода (promoPrice) либо стандартная salePrice
                                props.card.cartInfo.promoPrice !== null
                                    ? ({
                                        priceType: props.card.salePrice?.priceType,
                                        baseCardKey: props.card.salePrice?.baseCardKey,
                                        key: props.card.salePrice?.key,
                                        value: props.card.cartInfo.promoPrice,
                                    } as DomainNs.PriceFieldInterface)
                                    : props.card.salePrice
                            ),
                            oldPrice: props.card.oldPrice
                        }} />
                    </div>

                    <CartProductCardFavoriteV1 {...{
                        card: props.card,
                        cardIndex: props.cardIndex,
                        classes: [
                            'add-to-wishlist-v1'
                        ],
                        attrs: {
                            'add-to-wishlist-v1': 1,
                            'data-add-to-wishlist-v1-is-in-wishlist': 
                                props.card.favoriteInfo.status ? 1 : 0,
                            'data-add-to-wishlist-v1-product-type-id':
                                ProductTypeEnum.realModifier,
                            'data-add-to-wishlist-v1-id':
                                props.card.realModifierId,
                            'data-add-to-wishlist-v1-virtual-modifier-id':
                                props.card.virtualModifierId,
                        }
                    }} />
                    {
                        // в режиме редактирования нельзя выполнять
                        // никаких действий над товарами
                        (props.isReadonlyMode === false) && (
                            <CartProductCardDeleteV1 {...{
                                card: props.card,
                                cardIndex: props.cardIndex
                            }} />
                        )
                    }
                </div>

                <RemoveShimV1 {...{
                    card: props.card,
                    cardIndex: props.cardIndex
                }} />
            </div>

            {props.card.gifts.map((gift, index) => (
                <ProductCardV7AsCartGiftV1 key={`cgv1-${index}`} {...{
                    gift: gift,
                    card: props.card
                }} />
            ))}
            
        </>
    );

})

export default ProductCardV6;